module.exports = __webpack_public_path__ + "static/media/ExchangeRates.3803a310.svg";